import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

const stringEvent = (string) => {
  if(string.split(' | ').length > 1) {
    return string.split(' | ')[1]
  } else {
    return string;
  }
}

class RenderEvent extends Component {

  ordinalSuffix(i) {
    var j = i % 10,
        k = i % 100;
    if (j === 1 && k !== 11) {
        return i + "st";
    }
    if (j === 2 && k !== 12) {
        return i + "nd";
    }
    if (j === 3 && k !== 13) {
        return i + "rd";
    }
    return i + "th";
  }

  render() {
    if(!this.props.args.cellData) return '-';

    let realEvent = this.props.args.cellData[this.props.workoutIdx - 1];
    
    return(
      <Grid 
        container
        justify="space-around"
        spacing={16}>
        <Grid 
          item 
          className={'overflow-hack'}
          sm={12}
          xs={12}
          data-tip={''}>
          <strong>{realEvent.rank}</strong> ({realEvent.score_s}) 
        </Grid>
      </Grid>
    )
  }
}

RenderEvent.propTypes = {
  args: PropTypes.object.isRequired,
  workoutIdx: PropTypes.number.isRequired
}

export default RenderEvent;